var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-select w-2 block" }, [
    _c("div", { staticClass: "el-input is-disabled el-input--suffix" }, [
      _c("div", { staticClass: "loader mt-2 ml-3" }),
      _vm._v(" "),
      _c("span", { staticClass: "el-input__inner pl-6" }, [
        _vm._v("\n            " + _vm._s(_vm.message) + "\n        ")
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "el-input__suffix" }, [
      _c("span", { staticClass: "el-input__suffix-inner" }, [
        _c("i", {
          staticClass: "el-select__caret el-input__icon el-icon-arrow-up"
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }